export const getEmailDomain = (email: string) => email.split('@')[1]?.split('.')[0]?.toLowerCase()
export const getUrlDomain = (urlObj: URL) => {
  const hostname = urlObj.hostname
  const updatedHostname = hostname.startsWith('www.') ? hostname.slice(4) : hostname
  return updatedHostname.split('.')[0]?.toLowerCase()
}
